const searchParams = new URLSearchParams(location.search)
export const getRegion = () => {
  let region: any = ''

  const searchRegion = searchParams.get('region')
  const localRegion = localStorage.getItem('REGION')
  if (searchRegion) {
    region = searchRegion
  }
  if (localRegion) {
    region = localRegion
  }
  return region
}
